module.exports = __webpack_public_path__ + "img/mode1-2.ad18c0e1.png";